import React from "react";
import "./TrackOrder.css";

const TrackOrder = () => {
  return (
    <div className="trackorder-container">
      <h1>Track My Order</h1>
      <p>To track your order, please login to your account and view your recent purchases. We’ll keep you updated via email as well.</p>
    </div>
  );
};

export default TrackOrder;
